import React from "react";
import logo from "../static/logo.png";
import { useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

// 创建 memoized selector
const selectUrls = createSelector(
  (state: RootState) => state.apkUrl,
  (state: RootState) => state.exeUrl,
  // 只有当 apkUrl 或 exeUrl 变化时才会重新计算
  (apkUrl, exeUrl) => ({ apkUrl, exeUrl })
);

const Header: React.FC = () => {
  function isMobile() {
    const mobileReg =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileReg.test(navigator.userAgent);
  }

  // 使用 memoized selector
  const { apkUrl, exeUrl } = useSelector(selectUrls);

  return (
    <div className="w-full h-16 px-siderPad justify-between   flex items-center bg-[rgba(255,255,255,0.9)] backdrop-blur-[4px] text-[16px] fixed top-0 z-[10]">
      <div className="flex items-center gap-5">
        <div className="flex items-center gap-2">
          <img src={logo} alt="" className="w-[32px] h-[32px] " />
          <p className="text-[#333333FF] text-[20px]">DeepSurf</p>
        </div>
        <div className="w-[1px] h-[26px] bg-[#00000008]"></div>
        <p className="text-[#666666FF]">让科技触手科技</p>
      </div>
      <p
        className=" bg-[#4F6BFEFF] w-[146px] h-[32px] leading-[32px] text-center text-[#FFFFFFFF] text-[14px] rounded-full cursor-pointer hover:bg-[#4c67ee]"
        onClick={() => {
          window.open(isMobile() ? apkUrl : exeUrl);
        }}
      >
        开始使用DeepSurf
      </p>
    </div>
  );
};
export default Header;
